import type {
  SectionWithProgrammingsNodeView as GeneratedSectionWithProgrammingsNodeView,
  ProgrammingRangeView as GeneratedProgrammingRangeView,
} from "@/.generated/hey/v4b-backend/types.gen";

import { mapProgram } from "@/data/api/v4b/program/program.mapping";
import {
  mapApplianceCountByCategory,
  mapSectionCategoryReference,
} from "@/data/api/v4b/site-section/site-section.mapping";
import {
  ProgrammingRange,
  SectionNodePlanning,
} from "@/domains/v4b/site-programming-range/site-programming-range.types";
import { brandNumber, brandString } from "@/utils/branded";

function mapProgrammingRange(generatedRange: GeneratedProgrammingRangeView): ProgrammingRange {
  return {
    uuid: brandString(generatedRange.uuid),
    program: mapProgram(generatedRange.program),
    start: brandString(generatedRange.start),
    end: generatedRange.end ? brandString(generatedRange.end) : null,
  };
}

export function mapSectionNodePlanning(response: GeneratedSectionWithProgrammingsNodeView[]): SectionNodePlanning[] {
  return response.map((section) => ({
    sectionId: brandNumber(section.sectionId),
    name: section.name,
    parentId: section.parentId ? brandNumber(section.parentId) : undefined,
    category: section.category ? mapSectionCategoryReference(section.category) : undefined,
    applianceCountByProgrammingCategory: mapApplianceCountByCategory(section.applianceCountByProgrammingCategory),
    programmingRanges: section.programmingRanges.map(mapProgrammingRange),
    children: mapSectionNodePlanning(section.children),
  }));
}
